import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions, Errors} from 'react-redux-form';
import {ControlLabel, FormGroup} from 'react-bootstrap';
import DateTime from 'react-datetime';
import moment from 'moment';
import PropTypes from 'prop-types';

class RequiredDatePicker extends Component {
  state = {
    value: ''
  };
  handleChange = (value) => {
    const {
      model, dispatch, future, required
    } = this.props;

    if (typeof value === 'object') {
      this.setState({
        value,
      });
      dispatch(actions.change(model, value.format()));
      dispatch(actions.setValidity(model, { required: true }));

      if (Date.parse(value.format()) < new Date() && future) {
        dispatch(actions.setValidity(model, {future: false}));
      } else {
        dispatch(actions.setValidity(model, {future: true}));
      }
    } else {
      this.setState({
        value: '',
      });
      dispatch(actions.change(model, ''));
      if (required) {
        dispatch(actions.setValidity(model, {required: false}));
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    const {
      model, future, dispatch, required
    } = this.props;
    if (nextProps.value && this.state.value !== nextProps.value) {
      const value = moment(nextProps.value);
      this.setState({
        value
      });

      if (value) {
        dispatch(actions.change(model, value.format()));
        if (required) {
          dispatch(actions.setErrors(model, {required: true}));
        }
        // dispatch(actions.setErrors(model, required));

        if (Date.parse(value.format()) < new Date() && future) {
          dispatch(actions.setErrors(model, {future: true}));
        } else {
          dispatch(actions.setErrors(model, {future: false}));
        }
      }
    }
  }

  componentWillMount() {
    const {model, dispatch, required} = this.props;
    if (required) {
      dispatch(actions.setValidity(model, false));
    }
  }

  componentDidMount() {
    const {value} = this.props;
    if (this.state.value === '') {
      this.componentWillReceiveProps({value});
    }
    // dispatch(actions.change(model, this.state.value));
  }

  render() {
    return (
      <FormGroup
        className="ignite-datepicker"
        controlId={this.props.controlId}
        validationState={(this.state.value || !this.props.required) ? null : 'error'}
      >
        {this.props.label && (
          <ControlLabel>
            {this.props.label}
            {this.props.required ? '*' : ''}
          </ControlLabel>
        )}
        <DateTime
          className={this.props.classNames}
          closeOnSelect={!this.props.timeFormat}
          dateFormat={this.props.dateFormat}
          inputProps={{
            disabled: this.props.disabled,
            placeholder: this.props.placeholder
          }}
          onChange={this.handleChange}
          timeFormat={this.props.timeFormat}
          value={this.state.value}
        />

        <Errors
          className="errors"
          style={{height: '0px'}}
          messages={{
            required: 'This field is required',
            future: 'Date must be in the future'
          }}
          model={this.props.model}
          show
          dynamic
        />
      </FormGroup>
    );
  }
}

RequiredDatePicker.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  controlId: PropTypes.string,
  future: PropTypes.bool,
  dateFormat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  timeFormat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  disabled: PropTypes.any,
  required: PropTypes.bool
};

RequiredDatePicker.defaultProps = {
  future: false,
  controlId: Math.random()
    .toString(16)
    .substring(2),
  dateFormat: 'DD/MM/YYYY',
  timeFormat: false,
  required: true
};

export default connect()(RequiredDatePicker);



// WEBPACK FOOTER //
// ./src/components/common/form/elements/required-datepicker.jsx